import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import state from './state'

Vue.use(Vuex)

const defaultState = JSON.parse(JSON.stringify(state))

state.defaults = defaultState

const store = new Vuex.Store({
  // plugins: [VuexLoading.Store],
  state,
  getters,
  mutations,
  actions,
  modules: {},
  strict : !__PROD__
})

if (module.hot) {
  module.hot.accept([
    './getters',
    './actions',
    './mutation-types',
    './mutations'
  ], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      'mutations-types': require('./mutation-types'),
      mutations: require('./mutations')
    })
  })
}

export { mutations, getters }
export default store
